/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_portfolio_builder_portfolio_benchmark_PortfolioBenchmarkIdsOrg = {
    organization: string;
    period?: b2b_v1_portfolio_builder_portfolio_benchmark_PortfolioBenchmarkIdsOrg.period;
    portfolio_benchmark_ids: string;
};
export namespace b2b_v1_portfolio_builder_portfolio_benchmark_PortfolioBenchmarkIdsOrg {
    export enum period {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
    }
}

